import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { AlertCircleIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function PainPointsSection() {
  return <section className="py-20 bg-beige-warm md:py-32" data-id="element-66">
      <div className="px-4 mx-auto max-w-4xl sm:px-6 lg:px-8" data-id="element-67">
        {/* Problema Section */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} className="mb-24" data-id="element-68">
          <motion.h2 variants={itemVariants} className="mb-10 text-3xl font-bold text-center md:text-4xl text-charcoal font-playfair" data-id="element-69">
            Si eres mamá, probablemente te sientes así…
          </motion.h2>

          <motion.div variants={itemVariants} className="max-w-2xl mx-auto mb-12 overflow-hidden rounded-3xl shadow-md" data-id="element-70">
            <img src="https://cdn.magicpatterns.com/uploads/fQqgZLi2vNuWZXDfsuZRu3/Gemini_Generated_Image_ywnz0sywnz0sywnz.png" alt="Mamá ocupada trabajando desde casa" className="w-full h-auto object-cover" data-id="element-71" />
          </motion.div>

          <div className="max-w-2xl mx-auto mb-12 space-y-5" data-id="element-72">
            {['Tu día empieza corriendo y termina agotada', 'Siempre tienes mil cosas pendientes en la cabeza', 'Sientes que nunca haces suficiente', 'Quieres organizarte pero no sabes por dónde empezar', 'Te comparas con otras mamás que parecen tener todo bajo control'].map((point, index) => <motion.div key={index} variants={itemVariants} className="flex items-start p-4 bg-white shadow-sm rounded-2xl" data-id="element-73">
                <AlertCircleIcon className="flex-shrink-0 w-6 h-6 mr-4 text-sage mt-0.5" data-id="element-74" />
                <p className="text-lg text-charcoal/90" data-id="element-75">{point}</p>
              </motion.div>)}
          </div>

          <motion.div variants={itemVariants} className="p-8 mx-auto max-w-2xl text-center shadow-md bg-sage-light/30 rounded-3xl border border-sage-light/50" data-id="element-76">
            <p className="mb-2 text-xl font-bold text-sage-dark font-playfair" data-id="element-77">
              Y lo peor…
            </p>
            <p className="text-xl font-medium leading-relaxed text-charcoal" data-id="element-78">
              Tu mente nunca descansa.
              <br data-id="element-79" />
              Incluso cuando te acuestas, sigues pensando en todo lo que falta
              por hacer.
            </p>
          </motion.div>
        </motion.div>

        {/* Identificación Section */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} className="text-center" data-id="element-80">
          <motion.h3 variants={itemVariants} className="mb-4 text-2xl font-bold md:text-3xl text-charcoal font-playfair" data-id="element-81">
            La verdad es que el problema no es que seas desorganizada.
          </motion.h3>
          <motion.p variants={itemVariants} className="mb-10 text-lg text-charcoal/80" data-id="element-82">
            El problema es que estás sosteniendo demasiadas cosas al mismo
            tiempo:
          </motion.p>

          <motion.div variants={containerVariants} className="flex flex-wrap justify-center gap-3 mb-12" data-id="element-83">
            {['Trabajo', 'Hijos', 'Casa', 'Responsabilidades', 'Expectativas', 'Presión constante'].map((tag, index) => <motion.span key={index} variants={itemVariants} className="px-6 py-3 text-sm font-semibold tracking-wide bg-white shadow-sm text-charcoal rounded-full border border-sage-muted/20" data-id="element-84">
                {tag}
              </motion.span>)}
          </motion.div>

          <motion.div variants={itemVariants} className="max-w-3xl mx-auto" data-id="element-85">
            <p className="text-xl font-medium leading-relaxed text-charcoal md:text-2xl font-playfair" data-id="element-86">
              La mayoría de los métodos de productividad no están diseñados para
              la vida real de una mamá ocupada.{' '}
              <br className="hidden md:block" data-id="element-87" />
              <span className="text-sage" data-id="element-88">Por eso fallan.</span>
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}